import useTranslation from "next-translate/useTranslation";
import { open_province } from "pagesHelpers/ListingPagesHepler/SlugTransformation";
import formatUrl from "utils/FormatUrl";
import { norm } from "../ListingsRouterUrlHelper";
import FillCss from "./FillStyle.module.css";

const Types = {
  Appartement: "appartements",
  Maison: "maisons",
  Villa: "villas",
  Commerce: "locaux-magasins",
  Bureau: "bureaux",
  Terrain: "terrains",
  Riad: "riads",
  "local industriel": "locaux-industriels",
  "Local Industriel": "locaux-industriels",
  Studio: "studios",
};

function index({
  listingsSearchPayload,
  displayAnnonces,
}: {
  listingsSearchPayload: any;
  displayAnnonces?: any;
}) {
  const { t, lang } = useTranslation("villesprovincescommunes");

  return (
    <div className={`${displayAnnonces ? FillCss.Pathslinks : FillCss.links}`}>
      <a
        href={formatUrl("/", lang)}
        style={{ color: "#757E83" }}
        className={FillCss.arianeElement}
      >
        <span>{t("Immobilier")}</span> {">"}
      </a>
      {listingsSearchPayload?.transaction_type ? (
        <>
          <a
            className={FillCss.arianeElement}
            href={
              listingsSearchPayload?.transaction_type == "Vente"
                ? formatUrl("/acheter", lang)
                : listingsSearchPayload?.transaction_type == "Location"
                  ? formatUrl("/louer", lang)
                  : formatUrl("/acheter", lang)
            }
            style={{
              color:
                listingsSearchPayload?.province ||
                  (listingsSearchPayload?.commune &&
                    listingsSearchPayload?.commune != "") ||
                  listingsSearchPayload?.type?.length == 1
                  ? "#757E83"
                  : "#000",
            }}
          >
            <span>
              {listingsSearchPayload?.transaction_type == "Location"
                ? ` ${t("Louer")}`
                : ` ${t("Acheter")}`}
            </span>
            {listingsSearchPayload?.province ||
              (listingsSearchPayload?.commune &&
                listingsSearchPayload?.commune != "") ||
              listingsSearchPayload?.type.length == 1
              ? "> "
              : ""}
          </a>
        </>
      ) : null}

      {listingsSearchPayload?.province ? (
        listingsSearchPayload?.type && listingsSearchPayload?.type.length ? (
          <>
            {open_province.includes(listingsSearchPayload?.province) ? (
              <a
                className={FillCss.arianeElement}
                href={
                  listingsSearchPayload?.transaction_type == "Vente"
                    ? formatUrl(
                      `/acheter/immo-${norm(listingsSearchPayload?.province)
                        .toLowerCase()
                        .replace(/ /g, "-")
                        .replace("-ida--ou-tanane", "")
                        .replace("-ida-ou-tanane", "")
                        .replace("nouaceur", "bouskoura")
                        .replace("skhirate--temara", "temara")
                        .replace("skhirate--temara", "temara")
                        .replace("skhirate-temara", "temara")}`
                    )
                    : listingsSearchPayload?.transaction_type == "Location"
                      ? formatUrl(
                        `/louer/immo-${norm(listingsSearchPayload?.province)
                          .toLowerCase()
                          .replace(/ /g, "-")
                          .replace("-ida--ou-tanane", "")
                          .replace("-ida-ou-tanane", "")
                          .replace("nouaceur", "bouskoura")
                          .replace("skhirate--temara", "temara")
                          .replace("-assilah", "")}`
                      )
                      : formatUrl(
                        `/acheter/${listingsSearchPayload?.type.length == 1
                          ? listingsSearchPayload?.type + "/"
                          : ""
                        }/immo-${norm(listingsSearchPayload?.province)
                          .toLowerCase()
                          .replace(/ /g, "-")
                          .replace("-ida--ou-tanane", "")
                          .replace("-ida-ou-tanane", "")
                          .replace("nouaceur", "bouskoura")
                          .replace("skhirate--temara", "temara")
                          .replace("skhirate-temara", "temara")}`
                      )
                }
                style={{
                  color:
                    (listingsSearchPayload?.commune &&
                      listingsSearchPayload?.commune != "") ||
                      listingsSearchPayload?.type.length == 1
                      ? "#757E83"
                      : "#000",
                }}
              >
                <span>
                  {t(
                    listingsSearchPayload?.province
                      .replace("Nouaceur", "Bouskoura")
                      .replace("Skhirate- ", "")
                  )}
                  {listingsSearchPayload?.type &&
                    listingsSearchPayload?.type.length
                    ? " > "
                    : ""}
                </span>
              </a>
            ) : (
              <a
                className={FillCss.arianeElement}
                href={
                  listingsSearchPayload?.transaction_type == "Vente"
                    ? formatUrl(
                      `/acheter/immo-${norm(listingsSearchPayload?.province)
                        .toLowerCase()
                        .replace(/ /g, "-")
                        .replace("-ida--ou-tanane", "")
                        .replace("-ida-ou-tanane", "")
                        .replace("nouaceur", "bouskoura")
                        .replace("skhirate--temara", "temara")
                        .replace("skhirate-temara", "temara")}/annonces`
                    )
                    : listingsSearchPayload?.transaction_type == "Location"
                      ? formatUrl(
                        `/louer/immo-${norm(listingsSearchPayload?.province)
                          .toLowerCase()
                          .replace(/ /g, "-")
                          .replace("-ida--ou-tanane", "")
                          .replace("-ida-ou-tanane", "")
                          .replace("nouaceur", "bouskoura")
                          .replace("skhirate--temara", "temara")
                          .replace("skhirate-temara", "temara")}/annonces`
                      )
                      : formatUrl(
                        `/acheter/${listingsSearchPayload?.type.length == 1
                          ? listingsSearchPayload?.type + "/"
                          : ""
                        }/immo-${norm(
                          listingsSearchPayload?.province
                        )}/annonces`
                      )
                }
                style={{
                  color:
                    (listingsSearchPayload?.commune &&
                      listingsSearchPayload?.commune != "") ||
                      listingsSearchPayload?.type.length == 1
                      ? "#757E83"
                      : "#000",
                }}
              >
                {t(listingsSearchPayload?.province)}
                {listingsSearchPayload?.type &&
                  listingsSearchPayload?.type.length
                  ? " > "
                  : ""}
              </a>
            )}
          </>
        ) : (
          <>
            <span
              style={{
                color:
                  (listingsSearchPayload?.commune &&
                    listingsSearchPayload?.commune != "") ||
                    listingsSearchPayload?.type.length == 1
                    ? "#757E83"
                    : "#000",
              }}
            >
              {t(listingsSearchPayload?.province)}
              {listingsSearchPayload?.type && listingsSearchPayload?.type.length
                ? " > "
                : ""}
            </span>
          </>
        )
      ) : null}
      {typeof listingsSearchPayload?.type == "string" ||
        listingsSearchPayload?.type.length == 1 ? (
        open_province.includes(listingsSearchPayload?.province) &&
          ((typeof listingsSearchPayload?.quartier == "string" &&
            listingsSearchPayload?.quartier != "") ||
            listingsSearchPayload?.quartier?.length > 0) ? (
          <a
            className={FillCss.arianeElement}
            href={
              listingsSearchPayload?.transaction_type == "Vente"
                ? formatUrl(
                  `/acheter/immo-${norm(listingsSearchPayload?.province)
                    .toLowerCase()
                    .replace(/ /g, "-")
                    .replace("-ida--ou-tanane", "")
                    .replace("-ida-ou-tanane", "")
                    .replace("nouaceur", "bouskoura")
                    .replace("skhirate--temara", "temara")
                    .replace("skhirate-temara", "temara")}/vente-${Types[listingsSearchPayload?.type]
                      ? Types[listingsSearchPayload?.type]
                      : "appartements"
                  }`,
                  lang
                )
                : formatUrl(
                  `/louer/immo-${norm(listingsSearchPayload?.province)
                    .toLowerCase()
                    .replace(/ /g, "-")
                    .replace("-ida--ou-tanane", "")
                    .replace("-ida-ou-tanane", "")
                    .replace("nouaceur", "bouskoura")
                    .replace("skhirate--temara", "temara")
                    .replace("skhirate-temara", "temara")}/location-${Types[listingsSearchPayload?.type]
                      ? Types[listingsSearchPayload?.type]
                      : "appartements"
                  }`,
                  lang
                )
            }
            style={{
              color: listingsSearchPayload?.quartier ? "#757E83" : "#000",
            }}
          >
            <span>
              {t(listingsSearchPayload?.type)}
              {listingsSearchPayload?.quartier ? " > " : ""}
            </span>
          </a>
        ) : (
          <span
            className={FillCss.arianeElement}
            style={{
              color: listingsSearchPayload?.quartier ? "#757E83" : "#000",
            }}
          >
            <span>
              {t(listingsSearchPayload?.type)}
              {listingsSearchPayload?.quartier ? " > " : ""}
            </span>
          </span>
        )
      ) : null}
      {(typeof listingsSearchPayload?.quartier == "string" &&
        listingsSearchPayload?.quartier != "") ||
        listingsSearchPayload?.quartier?.length > 0 ? (
        <span className={FillCss.lastLink}>
          {listingsSearchPayload?.quartier
            ? t(`${listingsSearchPayload?.quartier}`)
            : ""}
        </span>
      ) : null}
    </div>
  );
}

export default index;
